import React, { useEffect, useState } from "react";
import { Table, Button, IconPlus, IconDownload } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import UploadModalDate from './UploadModalDate';
import XLSX from "xlsx";
import $ from 'jquery';

const RatesRender = ( props ) =>  {
    //Variables
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [dataRate, setDataRate] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [dateSelected, setDateSelected] = useState();
    const [buttonAddR, setButtonAddR] = useState(false);
    const [dataModifyR, setDataModifyR] = useState([]);
    const [datacounter, setdatacounter]=useState(1);

    //Metodos
    const fetchData = async () => {
        setDateSelected('');
        setDataRate([]);

        connectApi.get(
            "api/Channels/AllTables",
            { params: { viewRequired: 'rates' } },
            dataResponseLoad
        ).catch((error) => {
            setLoadingData(false);
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
        setLoadingData(true);
    };
    const dataResponseLoad = (status, data) => {
        data['rate'].forEach(x => {
            x.date = moment(x.date).format("MMM/DD/YYYY");
            if ( moment(x.date).format("MM/YYYY") === moment(data['date']).format("MM/YYYY") ){
                setButtonAddR(true);
                setDataModifyR(x);
            }
        });
        setDateSelected( moment(data['date']).format("MM-DD-YYYY") );
        setDataRate(data['rate'] === undefined ? [] : data['rate']);
        setLoadingData(false)
    };
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        fetchData();
    }, [datacounter]);

    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if (  orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } if( orderBy === "channel" || orderBy === "name" 
            || orderBy === "createdBy" || orderBy === "classification" 
            || orderBy === "description" || orderBy==="namecustomer" || orderBy==="nameEndUser" ){
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        } else if( orderBy === "startDate" || orderBy === "endDate"
                || orderBy === "date" || orderBy === "monthYear" ){
   
                    
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        }else{
            if (parseFloat(bSort) < parseFloat(aSort)) 
                return -1;
            if (parseFloat(bSort) > parseFloat(aSort))
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                    const aUpper = a[value] && a[value].toString().toUpperCase();
                    const filterUpper = filter && filter.toString().toUpperCase();
                    return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }

    //Vista
    const [showModalRate, setShowModalRate] = useState(false);
    const [orderBy, setOrderBy] = useState("date");
    const [orderType, setOrderType] = useState("descending");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 25;
    const [itemSelectRate, setItemSelectRate] = useState([]);
    const [modifyValuesRate, setModifyValuesRate] = useState(false);
    const [order, setOrder] = useState([
        'date',
        'indigoRate',
        'ptaxAverage'
    ]);
    const handlePageChange = (page) => setCurrentPage(page);
    const filteredData = filterSort(
        dataRate, { }, orderBy, orderType
    );
    let pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    function setModalParameters(e){
        var Datesel=$(e.target).closest('tr').children().eq(0).text();
        var Rate=$(e.target).closest('tr').children().eq(1).text();
        var Ptax=$(e.target).closest('tr').children().eq(2).text();

        if( Datesel!="Date" & Rate != "Rate" & Ptax!="PTax Average"  
        & new Date(dateSelected) <= new Date(Datesel) ){
            let vaItem = dataRate.find(gt => gt.indigoRate == Rate & gt.ptaxAverage == Ptax );
            setItemSelectRate(vaItem);
            setModifyValuesRate(true);
            setShowModalRate(true);
        }
    };

    return (<div>
        <Row>
            <Col 
                style={{
                    position: "absolute",
                    marginTop: "5px",
                }}
            >
                <Button
                    leadingIcon={<IconPlus />}
                    onClick={() => setShowModalRate(true)}
                    loading={loadingData}
                >{buttonAddR ? t("modifyLastValue")  : t("addNew") + " Rate"}</Button>
            </Col>
        </Row>
        <div>
            <Table
                onClick={setModalParameters}
                columns = {[
                    {
                        id: 'date',
                        label: t("date")
                    }, {
                        id: 'indigoRate',
                        label: "Rate"
                    }, {
                        id: 'ptaxAverage',
                        label: 'PTax Average'
                    }
                ]}
                showFilters
                columnReorder
                data={pagedData}
                loading={loadingData}
                onSort={handleSort}
                onColumnReorder={(reOrder) => setOrder(reOrder)}
                preferences={{
                    defaultOrder: order,
                    sortBy: {
                        id: orderBy,
                        type: orderType,
                    },
                    order: order
                }}
                pagination={{
                    currentPage,
                    onPageChange: handlePageChange,
                    pageSize,
                    totalItems: filteredData.length,
                }}
            />
            <div style={{ textAlign: "left" }}>
                <Button
                    onClick={()=>{
                        setTimeout(() => {
                        const dataXlsx = filteredData.map((item) => { return item; });
                        const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                        const wb = XLSX.utils.book_new();
                        const date = moment(new Date()).format('YYYYMMDDHHmm');
                        const filename = 'Rate-' + date + '.xlsx';
                        const ws_name = "Rate";
                        XLSX.utils.book_append_sheet(wb, ws, ws_name);
                        XLSX.writeFile(wb, filename);
                        }, 750);
                    }}
                    disabled={filteredData.length === 0}
                    leadingIcon={<IconDownload />}
                    title={t('download data')}
                    >
                    {t('download')}
                </Button>
            </div>
        </div>
        <UploadModalDate
            key={showModalRate ? true : false}
            showModal={showModalRate}
            setShowModal={setShowModalRate}
            tabView="rate"
            dataList={[]}
            dateInit={dateSelected}
            fetchData={useEffect}
            dataModify={dataModifyR}
            btnChange={buttonAddR}
            datacounter={datacounter}
            setdatacounter={setdatacounter}
            valueModify={modifyValuesRate}
            setValueModify={setModifyValuesRate}
            itemModify={itemSelectRate}
        />
    </div>);
}

export default RatesRender;
